var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddCardIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 18,
  fill: "#242E30",
  rx: 3
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#addCardIcon_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#addCardIcon_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2,
  d: "M12.092 4.307v4.101h4.101v1.184h-4.101v4.101h-1.184V9.592H6.807V8.408h4.101V4.307z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "addCardIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.25 3.75h10.5v10.5H6.25z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "addCardIcon_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.25 3.75h10.5v10.5H6.25z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCardIcon);
export default ForwardRef;